import { render, staticRenderFns } from "./ProductsDisplay.vue?vue&type=template&id=b018e876&scoped=true"
import script from "./ProductsDisplay.vue?vue&type=script&lang=js"
export * from "./ProductsDisplay.vue?vue&type=script&lang=js"
import style0 from "./ProductsDisplay.vue?vue&type=style&index=0&id=b018e876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b018e876",
  null
  
)

export default component.exports